import { Dialog } from '@progress/kendo-react-dialogs';
import { MarkdownRenderer } from '../../views/KnowledgeBase/MarkdownRenderer';
import { changelogEntries, ChangelogCategory } from './changelog';

const categoryColors: Record<ChangelogCategory, string> = {
  Feature: '#0E7C7B',
  Improvement: '#1355A2',
  Fix: '#0D1B2A',
};

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function formatDate(iso: string) {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${months[m - 1]} ${d}, ${y}`;
}

export default function WhatsNewDialog({ onClose }: { onClose: () => void }) {
  return (
    <Dialog title="What's New in Transcend" onClose={onClose} className="dialog-w800" autoFocus>
      <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {changelogEntries.length === 0 && <p>No updates yet.</p>}
        {changelogEntries.map((entry) => (
          <div key={entry.id} className="mb-4">
            <div className="d-flex align-items-center mb-1" style={{ gap: 8 }}>
              <span
                style={{
                  backgroundColor: categoryColors[entry.category],
                  color: '#fff',
                  borderRadius: 4,
                  padding: '2px 8px',
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {entry.category}
              </span>
              <span className="text-muted" style={{ fontSize: 13 }}>{formatDate(entry.date)}</span>
            </div>
            <h5 className="mb-1">{entry.title}</h5>
            <MarkdownRenderer markdown={entry.body} />
          </div>
        ))}
      </div>
    </Dialog>
  );
}
